<template>
    <div class="card card-tasks">
        <component v-bind:is="'Admin'+getCurrentSection()"></component>
    </div>
</template>
<script>
    import AdminAssignPerms from "./AdminAssignPerms";
    import AdminNewBoard from "./AdminNewBoard";

    export default {
        name: 'Admin',
        props: [],
        components: {
            AdminNewBoard,
            AdminAssignPerms
        },
        methods: {
           getCurrentSection(){
               return this.$root.navigation.itemId;
           }
        },
        data() {
            return {}
        }
    }
</script>
